import React, { useState } from 'react'
import {vectorPrev, searchs} from './../../assets'
import AvatarImage from './../../components/avatarImage'
import {fake} from './../../faker'
import { Link } from 'react-router-dom'

const Followers = () => {
    const [active, setActive] = useState('followers')
  return (
    <div>
        <div className='mt-[61px] md:mt-[40px] flex items-center justify-between mx-[30px] sm:mx-[190px]'>
            <Link to='/user'><img src={vectorPrev} alt="" /></Link>
            <div className='font-sans text-[20px] font-medium'>Username</div>
            <div></div>
        </div>
        <div className='flex flex-col items-center sm:mt-[30px] mt-[19px]'>
        <div className='flex justify-between max-w-[500px] w-full px-[60px] sm:px-[80px] items-center'>
            <div onClick={()=>setActive('followers')} className={`font-medium text-[14px] sm:text-[18px] cursor-pointer ${active==='followers' ? 'text-[black]' : 'opacity-50'}`}>200 followers</div>
            <div onClick={()=>setActive('following')} className={`font-medium text-[14px] sm:text-[18px] cursor-pointer ${active==='following' ? 'text-[black]' : 'opacity-50'}`}>300 following</div>
        </div>
        <div className='mx-[27px]'>
        <div className='rounded-[12px]  mt-[13px] bg-blue-inputBlue items-center flex w-[376px] md:w-[480px] h-[48px]'>
            <div className='pl-[16px] pr-[12px]'><img className='opacity-40 w-[24px] h-[24px]' src={searchs} alt="" /></div>
            <input className='outline-none border-none sm:text-[18px] text-gray-usersGray bg-inherit w-full' type="text" placeholder='Who would you like to add?' />
        </div>
        </div>
        </div>
        <div className='mt-[30px] flex gap-[16px] w-full flex-wrap'>
            { active==='followers' ?
                fake.map((item)=>(
                <div className='flex mx-[30px] w-full justify-between max-w-[334px] sm:max-w-[450px] items-center'>
                <div className='flex items-center  gap-[22px]'>
                <div>
                    <AvatarImage style={`w-[40px] h-[40px] sm:w-[100px] sm:h-[100px]`}/>
                </div>
                <div>
                    <div className='flex gap-[9px]'>
                        <div className='w-[100px] sm:h-[30px] h-[22px] overflow-hidden relative shadow-whiteShadow'>
                        <div className='text-[14px] w-full whitespace-nowrap absolute font-bold sm:text-[18px]'>{item.name}</div>
                        <div className='h-[50px] absolute right-[0] top-0  w-[60px] shadow-whiteShadow'></div>
                        </div>
                        {
                            item.followed &&
                        <div className='text-[14px] sm:text-[18px] font-[Poppins] cursor-pointer text-blue-chatBlue'>Follow</div>
                        }
                    </div>
                    <div className='text-[10px] sm:text-[14px] font-[Poppins] text-gray-usersGray'>Username</div>
                </div>
                </div>

                <div className='text-[12px]  sm:text-[16px]   cursor-pointer'>Remove</div>
            </div> 
                ))
            : active==='following' ?
            fake.map((item)=>(

                <div className='flex mx-[30px] w-full  justify-between max-w-[334px] sm:max-w-[450px] items-center'>
                <div className='flex items-center  gap-[22px]'>
                <div>
                    <AvatarImage style={`w-[40px] h-[40px] sm:w-[100px] sm:h-[100px]`}/>
                </div>
                <div>
                    <div className='flex gap-[9px]'>
                        <div className='relative w-[100px] sm:h-[30px] h-[22px]  sm:w-[130px] overflow-hidden shadow-whiteShadow'>
                        <div className='text-[14px] w-full whitespace-nowrap absolute font-bold sm:text-[18px]'>Jane Cooper</div>
                        <div className='h-[50px] absolute right-[0] top-0  w-[60px] shadow-whiteShadow'></div>
                        </div>
                        {/* <div className='text-[14px] sm:text-[18px] font-[Poppins] cursor-pointer text-white'>f</div> */}
                    </div>
                    <div className='text-[10px] sm:text-[14px] font-[Poppins] text-gray-usersGray'>Username</div>
                </div>
                </div>

                <div className='text-[12px]  sm:text-[16px]  cursor-pointer'>Unfollow</div>
            </div> 
            ))
                : null  
            }
        </div>
    </div>
  )
}

export default Followers